<template>
    <teleport to="head">
        <meta name="title" content="Portfolio | Journey As A Software Engineer"/>
        <meta name="description" content="The moment I discovered computer science I knew I would do it for the rest of my life. Here is my journey since then."/>
        <link rel="canonical" href="https://brandonaguirre.com/portfolio">
    </teleport>
    <div id="hire_me_section" >
        <div id="resume">
            <a href="https://brandonaguirre-website-images.s3.us-east-2.amazonaws.com/BrandonAguirreResume2021.pdf" target="_blank" download>Download my resume</a>
        </div>
        <div id="table_of_contents_wrap">
            <div id="head_section">
                <div id="photo_name_wrap">
                    <img :src="getImageUrl('headshot.jpeg')"/>
                    <div>
                        <h1>Brandon Aguirre</h1>
                        <p>B.S. Computer Science</p>
                    </div>
                </div>
                <div id="blurb_wrap">
                    <p>The moment I discovered computer science I knew I would do it for the rest of my life. Here is my journey since then.</p>
                </div>
            </div>
            <hr>
            <div id="list_section">
                <hire-me-menu :contents="toc"/>
            </div>
        </div>
        <div id="main_content_wrap">
            <suspense>
                <template #default>
                    <hire-me-main :contents="toc"/>
                </template>
                <template #fallback>
                    <h1 style="text-align: center; margin-top: 30vh;"><fa-icon class="spinner" :icon="['fa', 'spinner']"/></h1>
                </template>
            </suspense>
        </div>
    </div>
</template>

<script>
    import { defineAsyncComponent } from 'vue'
    import HireMeMenu from './HireMe/HireMeMenu'

    // async components
    const HireMeMain = defineAsyncComponent(() => import('./HireMe/HireMeMain'))

    export default {
        name: "HireMe",
        metaInfo () {
            console.log('foo')
            return {
                title: 'Hire Me'
            }
        },
        components: {
            HireMeMain,
            HireMeMenu,
        },
        data () {
            return {
                toc: [
                    { 
                        text: "Freelance Software Engineer",
                        date: '2020 - Current',
                        component: 'FreelanceTimeline'
                    },
                    { 
                        text: "Software Engineer at Boulder Start up",
                        date: 'May 2019 - Aug 2020 • 14 mos',
                        component: 'FiTimeline'
                    },
                    { 
                        text: "New Venture Challenge Finalist (Awarded $11,000)",
                        date: 'Mar 2019',
                        component: 'NvcTimeline'
                    },
                    { 
                        text: "Machine Learning Internship",
                        date: 'May 2018 - Sep 2018 • 5 mos',
                        component: 'MachineLearningTimeline'
                    },
                    { 
                        text: "Software Engineer Internship",
                        date: 'May 2017 - Aug 2017 • 4 mos',
                        component: 'SoftwareEngineerTimeline'
                    },
                    { 
                        text: "Funded Undergraduate Research",
                        date: 'Sep 2016 - May 2017 • 9 mos',
                        component: 'ResearchTimeline'
                    },
                    { 
                        text: "Comp Sci Course Assistant & Tutor at CU Boulder",
                        date: 'Aug 2016 – Dec 2017 • 15 mos',
                        component: 'CourseAssistantTimeline'
                    }
                ]
            } 
        },
        computed: {
            labels () {
                return this.toc.map(item => item.date)
            }
        },
        methods: {
            emptyList (n) {
                let foo = []
                for (let i = 0; i < n; i ++) foo.push(i)
                return foo
            }
        },
        mounted () {
            window.scrollTo(0, 0)
        },
        unmounted () {
            window.scrollTo(0, 0)
        }
    }
</script>

<style scoped lang="scss">
    @import "~@/assets/variables";

    $menu-width: 300px;
    $menu-padding: 10px;

    #resume {
        position: fixed;
        z-index: 99;
        top: 65px;
        right: 10px;
        background: white;
        border-radius: 50px;
        box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);
        padding: 10px 15px;
        display: inline-block;
        a {
            color: $green;
        }
    }

    #hire_me_section {
        position: relative;
        height: 100%;
        #table_of_contents_wrap {
            padding: 0 ($menu-padding);
            width: $menu-width - (2*$menu-padding);
            position: fixed;
            top: 50px;
            left: 0;
            height: calc(100% - 100px);
            max-height: calc(100% - 100px);
            overflow-y: scroll;

            #head_section {
                padding-top: 20px;
                #photo_name_wrap {
                    display: flex;
                    justify-content: space-around;
                    align-content: center;

                    > img {
                        background: grey;
                        border-radius: 50%;
                        width: 100px;
                        height: 100px;
                    }

                    > div {
                        h1 { 
                            font-size: 1.3rem;
                        }
                    }
                }

                #blurb_wrap {
                    text-align: center;
                    line-height: 1.5rem;
                }
            }

            #list_section {
                
            }
        }

        #main_content_wrap {
            padding: 0px 20px 50px 10px;
            margin-left: $menu-width;

            h1 {
                margin: 0;
            }
            
        }
    }

    .spinner {
        color: $green;
        font-size: 3rem;
        animation: spin 1.2s infinite;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

    @media only screen and (max-width: 768px) {
        #hire_me_section {
            #table_of_contents_wrap {
                padding: 0 ($menu-padding);
                width: auto;
                position: relative;
                top: 0;
                left: 0;
                height: none;
                max-height: none;
                overflow: initial;

                .har {
                    display: none;
                }

                #list_section {
                    display: none;
                }
            }

            #main_content_wrap {
                padding: 0px 20px 50px 20px;
                margin: 0;
            }
        }

        #resume {
            top: initial;
            bottom: 15px;
        }
    }
</style>